import { CustomForm, CustomFormGroup } from "@tilby/tilby-ui-lib/components/tilby-magic-form";
import { ProvValidator } from "@tilby/tilby-ui-lib/utilities";
import { Vat } from "tilby-models";

export class VatRatesFe implements Vat {
    id: number = -1;
    code?: string = "";
    value: number = 0;
}

export type VatRatesFields = Vat;

export type VatRatesFieldsNullable = { [prop in string & keyof VatRatesFields]: VatRatesFields[prop] | null };
export type VatRatesForm = Partial<CustomForm<VatRatesFieldsNullable>>;

export type VatRatesFormGroups = CustomFormGroup<VatRatesForm>;

export interface VatRatesValidators extends ProvValidator {
    valueMinValue: number;
}

export const filterableVatRatesColumnsWithSearchBar: (keyof VatRatesFe)[] = ["value"];